import { getMatchCriterionLabelKey } from '../../../../../../RentalPortalMatch'

export function getMatchRulesAddCriterionOptions({ options, t }) {
  return options.map(option => ({
    label: t(getMatchCriterionLabelKey(option.key)),
    value: option.key,
  }))
}
